import React, { Component } from 'react';
import { Icon } from 'antd'; // 👈 Using built-in Ant Design icons to prevent missing SVG errors
import { connect } from 'react-redux';
import { getPushPathWrapper } from '../../../routes';

const actions = [
  {
    icon: 'file-add',
    title: 'Add Manuscript',
    subtitle: 'Create a manual submission record',
    routeKey: 'article.add' // 👈 Maps to /article/add
  },
  {
    icon: 'profile',
    title: 'Add Abstract',
    subtitle: 'Create a new online abstract',
    routeKey: 'onlineAbstractsGroup.addAbstract' // 👈 Maps to /abstract/add
  },
  {
    icon: 'calendar',
    title: 'Add Event',
    subtitle: 'Schedule and manage new events',
    routeKey: 'manageEvents' // 👈 Maps to /events
  },
  {
    icon: 'form',
    title: 'Add Blog',
    subtitle: 'Publish a new blog post',
    routeKey: 'blogs.addBlog' // 👈 Maps to /blogs/add-blog
  }
];

class QuickActions extends Component {
  render() {
    const { dispatch } = this.props;

    return (
      <div className="adminCard quickActionsCard">
        <div className="adminCardHeader">
          <div className="adminCardTitleBlock">
            <div className="adminCardTitle">Quick Actions</div>
            <div className="adminCardSubtitle">Frequently used administration tools</div>
          </div>
        </div>

        <div className="cardDivider"></div>

        <div className="actionGrid">
          {actions.map((item, key) => (
            <div
              className="actionCard"
              key={key}
              style={{ cursor: 'pointer' }} // 👈 Makes it look clickable
              onClick={() => dispatch(getPushPathWrapper(item.routeKey))}
            >
              <Icon
                type={item.icon}
                className="actionIcon"
                style={{ fontSize: 22, color: '#1f6b4f', marginBottom: 12 }}
              />
              <div className="actionTitle">{item.title}</div>
              <div className="actionSub">{item.subtitle}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
export default connect()(QuickActions);